var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-section-element"},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.options.title),expression:"options.title"}],staticClass:"form-section form-section-primary"},[_vm._v(_vm._s(_vm.options.title))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.options.info),expression:"options.info"}],staticClass:"form-section-info",domProps:{"innerHTML":_vm._s(_vm.options.info)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69ee9770","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormSection.vue
// module id = 882
// module chunks = 1